import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import dropdownImg from "../assets/dropDownArrow.svg";
import { RiArrowDropDownLine } from "react-icons/ri";
import { RiArrowDropUpLine } from "react-icons/ri";
import { NavbarImages } from "../utils/constants";

const NavbarLinks = ({ bgColor, setOpenModal, hamburgerRef }) => {
  const [selectedLink, setSelectedLink] = useState("");
  const onHandleClick = (value) => {
    setOpenModal(false);
    setSelectedLink(value);
  };
  const navigate = useNavigate();
  const [aboutOpen, setAboutOpen] = useState(false);
  const [colOpen, setColOpen] = useState(false);
  return (
    <div
      ref={hamburgerRef}
      className="flex w-[100%]  flex-col items-start justify-center absolute border-t border-gray-400 z-30 top-[80px] shadow-md rounded-br-md rounded-bl-md right-[1px] px-4 py-2 "
      style={{ background: bgColor ? bgColor : "white" }}
    >
      <ul className="flex flex-col text-base w-full font-medium text-[#D31C4F] gap-2">
        <li className="flex flex-row border-b border-[#d31c4f] border-opacity-20 justify-between">
          <div
            onClick={() => {
              navigate("/about#first");
              onHandleClick("about");
            }}
            className={`flex cursor-pointer flex-row py-2 items-center gap-3 ${
              selectedLink === "about" && "text-[#0D4F9E]"
            }`}
          >
            <img src={NavbarImages.aboutImg} alt="about" className="h-5 w-5" />
            <p className="mt-1">About</p>
          </div>
          {aboutOpen ? (
            <RiArrowDropUpLine
              className="text-4xl  w-[100px] pl-[58px] mt-1 cursor-pointer"
              onClick={() => setAboutOpen(false)}
            />
          ) : (
            <RiArrowDropDownLine
              className="text-4xl  w-[100px] pl-[55px] mt-1 cursor-pointer"
              onClick={() => setAboutOpen(true)}
            />
          )}
        </li>
        {aboutOpen && (
          <div className="flex flex-col text-sm font-normal text-black">
            <p
              onClick={() => {
                navigate("/positiveParenting");
                onHandleClick("positiveParenting");
              }}
              className={`flex py-2 cursor-pointer font-medium flex-row items-center gap-3 ${
                selectedLink === "positiveParenting" &&
                "underline underline-offset-2"
              }`}
            >
              Positive Parenting
            </p>
            <p
              onClick={() => {
                navigate("/branch");
                onHandleClick("branch");
              }}
              className={`flex py-2 font-medium cursor-pointer flex-row items-center gap-3 ${
                selectedLink === "branch" && "underline underline-offset-2"
              }`}
            >
              Branch
            </p>

            <p
              onClick={() => {
                navigate("/getInTouch");
                onHandleClick("getInTouch");
              }}
              className={`flex py-2 cursor-pointer font-medium flex-row items-center gap-3 ${
                selectedLink === "getInTouch" && "underline underline-offset-2"
              }`}
            >
              Get In Touch
            </p>
          </div>
        )}
        <li className="border-b border-[#d31c4f] border-opacity-20">
          <div
            onClick={() => {
              navigate("/admission");
              onHandleClick("admission");
            }}
            className={`flex py-2 cursor-pointer flex-row items-center gap-3 ${
              selectedLink === "admission" && "text-[#0D4F9E]"
            }`}
          >
            <img
              src={NavbarImages.admissionImg}
              alt="admission"
              className="h-5 w-5 "
            />
            <p>Admission</p>
          </div>
        </li>
        <li className="border-b border-[#d31c4f] border-opacity-20">
          <div
            onClick={() => {
              navigate("/thoughtLeadership");
              onHandleClick("thought");
            }}
            className={`flex py-2 cursor-pointer flex-row items-center gap-3 ${
              selectedLink === "thought" && "text-[#0D4F9E]"
            }`}
          >
            <img
              src={NavbarImages.thoughtImg}
              alt="admission"
              className="h-5 w-5 "
            />
            <p>Thought Leadership</p>
          </div>
        </li>
        <li className="border-b border-[#d31c4f] flex flex-row justify-between border-opacity-20">
          <div
            onClick={() => {
              navigate("/curriculumOfLove");
              onHandleClick("col");
            }}
            className={`flex py-2 cursor-pointer flex-row items-center gap-3 ${
              selectedLink === "col" && "text-[#0D4F9E]"
            }`}
          >
            <img
              src={NavbarImages.colLinkImg}
              alt="admission"
              className="h-5 w-5 "
            />
            <p>Curriculum of Love</p>
          </div>
          {colOpen ? (
            <RiArrowDropUpLine
              className="text-4xl w-[100px] pl-[55px] mt-1 cursor-pointer"
              onClick={() => setColOpen(false)}
            />
          ) : (
            <RiArrowDropDownLine
              className="text-4xl w-[100px] pl-[55px] mt-1 cursor-pointer"
              onClick={() => setColOpen(true)}
            />
          )}
        </li>
        {colOpen && (
          <div className="flex flex-col text-sm font-normal text-black">
            <p
              onClick={() => {
                navigate("/teachingMethod");
                onHandleClick("teachingMethod");
              }}
              className={`flex py-1 font-medium cursor-pointer flex-row items-center gap-3 ${
                selectedLink === "teachingMethod" &&
                "underline underline-offset-2"
              }`}
            >
              Teaching methodology
            </p>
            <p
              onClick={() => {
                navigate("/programs");
                onHandleClick("programs");
              }}
              className={`flex py-1 mt-1 font-medium cursor-pointer flex-row items-center gap-3 ${
                selectedLink === "programs" && "underline underline-offset-2"
              }`}
            >
              Our Programmes
            </p>
            <p
              onClick={() => {
                navigate("/dignitory");
                onHandleClick("dignitory");
              }}
              className={`flex py-2 font-medium cursor-pointer flex-row items-center gap-3 ${
                selectedLink === "dignitory" && "underline underline-offset-2"
              }`}
            >
              Dignitaries
            </p>
            <p
              onClick={() => {
                navigate("/facilities");
                onHandleClick("facilities");
              }}
              className={`flex py-2 font-medium cursor-pointer flex-row items-center gap-3 ${
                selectedLink === "facilities" && "underline underline-offset-2"
              }`}
            >
              Facilities
            </p>
            <p
              onClick={() => {
                navigate("/events");
                onHandleClick("events");
              }}
              className={`flex py-2 font-medium cursor-pointer flex-row items-center gap-3 ${
                selectedLink === "events" && "underline underline-offset-2"
              }`}
            >
              Events
            </p>
            <p
              onClick={() => {
                navigate("/celebration");
                onHandleClick("celebration");
              }}
              className={`flex py-2 font-medium cursor-pointer flex-row items-center gap-3 ${
                selectedLink === "celebration" && "underline underline-offset-2"
              }`}
            >
              Celebrations
            </p>
            <p
              onClick={() => {
                navigate("/activities");
                onHandleClick("activities");
              }}
              className={`flex py-2 font-medium cursor-pointer flex-row items-center gap-3 ${
                selectedLink === "activities" && "underline underline-offset-2"
              }`}
            >
              Activities
            </p>
            <p
              onClick={() => {
                navigate("/monthCal");
                onHandleClick("monthCal");
              }}
              className={`flex py-2 font-medium cursor-pointer flex-row items-center gap-3 ${
                selectedLink === "monthCal" && "underline underline-offset-2"
              }`}
            >
              Month at a glance
            </p>
            <p
              onClick={() => {
                navigate("/calendar");
                onHandleClick("calendar");
              }}
              className={`flex py-2 font-medium cursor-pointer flex-row items-center gap-3 ${
                selectedLink === "calendar" && "underline underline-offset-2"
              }`}
            >
              List of Holidays
            </p>
          </div>
        )}
        <li className="border-b border-[#d31c4f] border-opacity-20">
          <div
            onClick={() => {
              navigate("/interactiveGallery");
              onHandleClick("gallery");
            }}
            className={`flex py-2 cursor-pointer flex-row items-center gap-3 ${
              selectedLink === "gallery" && "text-[#0D4F9E]"
            }`}
          >
            <img
              src={NavbarImages.galleryImg}
              alt="admission"
              className="h-5 w-5 "
            />
            <p>Gallery</p>
          </div>
        </li>
        <li>
          <div
            onClick={() => {
              navigate("/getInTouch");
              onHandleClick("contact");
            }}
            className={`flex cursor-pointer py-2 flex-row items-center gap-3 ${
              selectedLink === "contact" && "text-[#0D4F9E]"
            }`}
          >
            <img
              src={NavbarImages.contactImg}
              alt="admission"
              className="h-5 w-5 "
            />
            <p>ContactUs</p>
          </div>
        </li>
      </ul>
      <div className=" text-center my-auto mt-2">
        <button
          className={
            "border-[2px] border-[#65B2C0] rounded-2xl mt-5 mb-2 text-[#65B2C0] px-6 py-2 min-w-[150px] font-Lato"
          }
        >
          <Link to="/login">Parents Login</Link>
        </button>
      </div>
    </div>
  );
};

export default NavbarLinks;
